import { render } from "./SketchDivider.vue?vue&type=template&id=6a1f968a"
import script from "./SketchDivider.vue?vue&type=script&lang=js"
export * from "./SketchDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__